/* One measured stack for the announcement, desktop menus and mobile drawer. */
(() => {
 const header=document.querySelector('.loncry-sticky-site-header');
 if(!header)return;
 function sync(){const height=Math.ceil(header.getBoundingClientRect().height);if(height>0){document.documentElement.style.setProperty('--loncry-fixed-header-height',height+'px');document.documentElement.style.setProperty('--loncry-mobile-header-height',height+'px')}}
 sync();if('ResizeObserver' in window)new ResizeObserver(sync).observe(header);
 window.addEventListener('resize',sync,{passive:true});window.addEventListener('pageshow',sync);document.fonts?.ready.then(sync);
})();
